import { render, staticRenderFns } from "./AttestationToDoDetails.vue?vue&type=template&id=12aaf638"
import script from "./AttestationToDoDetails.vue?vue&type=script&lang=js"
export * from "./AttestationToDoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports